import type {RotateProperty} from "../../_types/RotateProperty";
import {SceneObjectWithColorData} from "../../_types/SceneObjectWithColorData";
import type {Size} from "../../_types/Size";
import type {WebGLRenderObject} from "../../_types/WebGLRenderObject";
import {getRandomNumberBetween} from "../../helpers/getRandomNumberBetween";
import {ObjectPipelinePass} from "../ObjectPipeline";

export class RotateObjectPass implements ObjectPipelinePass {

    constructor(
        private sceneSize: Size,
        private options: RotateProperty) {}

    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    public apply(
        index: number,
        renderObject: WebGLRenderObject,
        sceneObjects: Array<SceneObjectWithColorData>
    ): void {

        renderObject.rotation = this.options.amount * (Math.PI / 180);

        if (this.options.randomize) {
            renderObject.rotation += getRandomNumberBetween(
                360 * -this.options.randomize,
                360 * this.options.randomize) * (Math.PI / 180);
        }
    }
}